export default {"src":"https://fishbrain.com/_next/static/media/missouri.acfefff1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};